<template>
    <div>
        <el-form label-width="95px" size="mini" >
            <el-form-item class="form-title" label="收款公司">
                <div >{{formData.vc_gsname}}</div>
            </el-form-item>
            <el-form-item class="form-title" label="付款方">
                <div >{{formData.vc_khname}}</div>
            </el-form-item>
            <div class="flex">
                <el-form-item class="w50" label="类型">
                    <el-select style="width: 200px"  v-model="formData.i_sktype" size="mini">
                        <el-option

                                v-for="item in lxList"
                                :key="item.value"
                                :label="item.text"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item class="w50" label="到账日期">
                    <el-date-picker
                            value-format="yyyy-MM-dd"
                            format="yyyy-MM-dd"
                            size="mini"
                            class="input"
                            v-model="formData.dt_paytime"
                            type="date"
                            style="width: 100%"
                            placeholder="到账日期"
                            :clearable="false"
                            :picker-options="pickerOptions"
                            :disabled-date="disabledDate"
                    >
                    </el-date-picker>
                </el-form-item>
            </div>
            <div class="flex">
                <el-form-item class="w50" label="币种">
                    <el-select style="width: 200px"  v-model="formData.i_bzid" size="mini" @change="chooseBzFun">
                        <el-option

                                v-for="item in data.bzList"
                                :key="item.i_id"
                                :label="item.vc_name"
                                :value="item.i_id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item class="w50" label="汇率">
                    <div style="text-align: right">{{formData.f_rate}}</div>
                </el-form-item>
            </div>
            <div class="flex">
                <el-form-item class="w50" prop="i_flag" label="是否预收">
                    <el-radio-group style="width: 200px"  v-model="formData.i_flag">
                        <el-radio  :label="0">否</el-radio>
                        <el-radio :label="1">是</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item class="w50 " prop="title" label="收款金额" >
                    <el-input class="dib w100-15" style="text-align: right" v-model="formData.f_pay" clearable placeholder="请输入收款金额" size="mini" ></el-input>
                    <div  class="dib "  style="text-align: right;width: 45px">{{formData.vc_showname}}</div>
                </el-form-item>
            </div>

            <el-form-item  prop="vc_note" :label="$t('form_notes')" >
                <el-input
                        size="mini"
                        class="input"
                        placeholder="输入备注"
                        v-model="formData.vc_note"
                        clearable>
                </el-input>
            </el-form-item>
            <div class="dfjc">
                <div>
                    <span style="display: inline-block;width: 75px">制单人:</span>
                    <span>{{formData.vc_lruname}}</span>
                </div>
                <div>
                    <span style="display: inline-block;width: 75px">制单日期:</span>
                    <span>{{formData.dt_createtime}}</span>
                </div>
            </div>
        </el-form>
        <div class="center">
            <el-button type="primary" @click="confirm" :disabled="disabled" :class="baseerp+'btn'" size="small" >保存</el-button>
            <el-button @click="goback" size="mini">{{$t('button_cancel')}}</el-button>

        </div>

    </div>
</template>

<script>
    import * as API from "./api"
    import {baseerp} from "@/utils/baseUrl";

    export default {
        name: "AddNew",
        props:{
            data:{
                type:Object,
                required:true
            }
        },
        '$root.workSize':{
            handler(n,o) {
                this.onResize(n);
            },
            deep:true,
        },
        components: {},
        data() {
            return {
                formData:{
                },
                disabled:false,
                baseerp:'',
                lxList:[{value:1,text:'现金'},{value:3,text:'电汇'},{value:4,text:'支票'},{value:5,text:'汇票'}],
                pickerOptions:{
                    disabledDate(time){
                        const date=new Date();
                        return time.getTime()>date.getTime()

                    },
                },
            }
        },
        mounted() {
            this.formData={
                i_gsid:this.data.i_gsid,
                i_khid:this.data.i_khid,
                vc_khname:this.data.vc_khname,
                vc_gsname:this.data.vc_gsname,
                dt_paytime:this.getDay(),
                vc_lruname:sessionStorage.getItem("lruname"),
                dt_createtime:this.getDay(),
                i_bzid:this.data.bzList[0].i_id,
                f_rate: this.data.bzList[0].f_rate,
                vc_showname: this.data.bzList[0].vc_showname,
                i_flag:0
            }
            this.baseerp = baseerp;
            this.$nextTick(()=>{
                this.onResize();
            })
        },
        methods: {
            onResize (n){
                if (n==undefined) n=this.$root.workSize;
                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h*0.5
                if(this.tableHeight<60)this.tableHeight=60
            },
            confirm(){
                this.$confirm('是继续保存','提示',{
                    confirmButtonText:'继续',
                    cancelButtonText:'取消',
                    type:'warning'
                }).then(async()=>{
                    if(this.formData.i_bzid&&this.formData.i_sktype&&this.formData.f_pay&&this.formData.f_pay>=0){
                        this.savePaymentRec()

                    }else{
                        this.$message.warning('请填写完整信息')
                    }
                }).catch(()=>{
                    this.$message({
                        type:'info',
                        message:'已取消'
                    })
                })
            },
            disabledDate(time){
                // const date=new Date();
                // console.log(time,'===============')
                // return time.getTime()>date.getTime()

            },
            chooseBzFun(val){
                let obj=this.data.bzList.find(o=>o.i_id==val);
                // console.log(obj,'-------',val)

                if(obj!==undefined){
                    this.formData.f_rate= obj.f_rate
                    this.formData.vc_showname=obj.vc_showname
                    this.$forceUpdate()
                }
            },
            goback(){
                this.$emit('close',this.back)
            },
            getDay(){
                const date=new Date();
                const y=date.getFullYear()
                const m=(date.getMonth()+1).toString().padStart(2,'0');
                const d=date.getDate().toString().padStart(2,'0');
                return y+'-'+m+'-'+d
            },
            async savePaymentRec(){
                this.disabled=true
                let param=this.formData
                let res=await API.savePaymentRec(param);
                if ( res.code == 1 ){
                    this.$message.success(res.message);
                    this.$emit('close','save')
                }else if (res.code == -2) {
                    this.disabled=false

                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.disabled=false

                    this.$message.error(res.message);
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    .dib{
        display: inline-block;
    }
    .flex{
        display: flex;

    }
    .w50{
        width: 50%;
        text-align: left;
    }
    .dfjc{
        display: flex;
        justify-content: space-between;
    }
    .el-dialog__title,.el-dialog__headerbtn .el-dialog__close {
        color: white;
    }
    .center{
        text-align: center;
    }
    .w100-15{
        width: calc(100% - 45px);
    }
</style>